import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import {Button, TextField,Grid} from '@material-ui/core'
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { ModalHeader } from 'reactstrap';
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';

const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
function EditThisSRapport(props) {
    const [id,setId] = React.useState("")
    const [Email,setEmail] = React.useState("")
    const [name,setName] = React.useState("")
    const [beskrivning,setBeskrivning] = React.useState("")
    const [EmailError,setEmailError] = React.useState("")
    
    React.useEffect(()=>{
        console.log(props.item)
        setId(props.item.id)
        setEmail(props.item.Email)
        setName(props.item.Name)
        setBeskrivning(props.item.Beskrivning)
    },[props.item])
    const isEmail =(Email)=>{
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (Email.match(validRegex)) {return true;} 
        else {return false;}
    }
    const onSaveThisRapport=()=>{
        let item = {
            ...props.item,
            Email:Email, 
            Name:name, 
            Beskrivning:beskrivning, 
        }
        props.EditThisRapport(item)
    }
    return (
        <>
             <Dialog open={true} 
              onClose={props.handleClose} 
              aria-labelledby="customized-dialog-title" 
              fullWidth={true} 
              maxWidth={"xs"}>
                  <ModalHeader className="modal-box-header bg-primary text-white">
                    <IntlMessages id="Report.Edit.header"/>
                    <IconButton className="text-white"
                        onClick={props.handleClose}>
                        <CloseIcon />
                    </IconButton>
                </ModalHeader>
                        <DialogContent divider>
                        <DialogContentText id="alert-dialog-description">                        
                        <Grid container>
                            <Grid item xs={12} className="mt-2">
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                defaultValue=""
                                size="small"
                                name="name"
                                label={<IntlMessages id="input.Name"/>}
                                value={name}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e)=>{setName(e.target.value)}}
                                />
                            </Grid>
                            <Grid item xs={12} className="mt-2">
                            <TextField 
                                variant="outlined" 
                                fullWidth
                                defaultValue=""
                                size="small"
                                name="beskrivning"
                                label={<IntlMessages id="input.Description"/>}
                                multiline
                                rows={ 5 }
                                value={beskrivning}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e)=>{setBeskrivning(e.target.value)}}
                                />
                            </Grid>
                            <Grid item xs={12} className="mt-2">
                                <TextField 
                                variant="outlined" 
                                fullWidth
                                defaultValue=""
                                size="small"
                                name="Email"
                                error={EmailError}
                                label={<IntlMessages id="Label.send.to.Email"/>}
                                value={Email}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e)=>{setEmail(e.target.value)}}
                                />
                            </Grid>                            
                        </Grid>
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button
                        variant="contained"
                        color="primary"
                        className="jr-btn"
                        disabled={isEmpty(Email) || isEmpty(name)?true:!isEmpty(EmailError)}
                        onClick={onSaveThisRapport}
                        autoFocus
                        ><IntlMessages id="Save"/>
                        </Button>
                        </DialogActions>
                        
            </Dialog> 
        </>
    );
}

export default EditThisSRapport;